import { render, staticRenderFns } from "./Advert7.vue?vue&type=template&id=76f6f97f&scoped=true&"
import script from "./Advert7.vue?vue&type=script&lang=ts&"
export * from "./Advert7.vue?vue&type=script&lang=ts&"
import style0 from "./Advert7.vue?vue&type=style&index=0&id=76f6f97f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f6f97f",
  null
  
)

component.options.__file = "Advert7.vue"
export default component.exports